import IncidentReport from "../fragments/incidentReport";

export default `
query QueryIncidentReportsByPropertyIdStartTimeIndex($propertyId: ID!, $from: Float, $to: Float, $after: String, $includeDeleted: Boolean) {
  queryIncidentReportsByPropertyIdStartTimeIndex(
    propertyId: $propertyId, 
    from: $from, 
    to: $to, 
    after: $after,
    includeDeleted: $includeDeleted
  ) {
    items ${IncidentReport}
    nextToken
  }
}
`;
